// Available vegetable/garden icons for plant creation (icon key -> display name for picker)
export const VEGETABLE_ICONS = {
  "rose": "Rose",
  "tomato": "Tomato",
  "leafy-green": "Salad",
  "cucumber": "Cucumber",
  "radish": "Radish",
  "onion": "Onion",
  "garlic-alt": "Garlic",
  "pepper": "Pepper",
  "pepper-alt": "Bell Pepper",
  "pepper-hot": "Chili Pepper",
  "carrot": "Carrot",
  "broccoli": "Broccoli",
  "watermelon": "Watermelon",
  "strawberry": "Strawberry",
  "pumpkin": "Squash",
  "flower": "Flower",
  "flower-daffodil": "Daffodil",
  "flower-tulip": "Tulip",
  "avocado": "Avocado",
  "banana": "Banana",
  "cherry": "Cherry",
  "corn": "Corn",
  "grape": "Grape",
  "leaf": "Leaf",
  "lettuce": "Lettuce",
  "lemon": "Lemon",
  "mushroom": "Mushroom",
  "peach": "Peach",
  "peanut": "Peanut",
  "peapod": "Pea",
  "pear": "Pear",
  "potato": "Potato",
  "apple-whole": "Apple",
  "seedling": "Seedling",
  "plant-growth": "Plant",
  "aubergine": "Aubergine",
  "salad": "Salad bowl",
  "olive": "Olive",
  "melon": "Melon",
  "pineapple": "Pineapple",
  "kiwi-fruit": "Kiwi",
  "coconut": "Coconut",
  "blueberries": "Blueberries",
  "wheat": "Grain",
  "spa": "Sprig",
  "clover-alt": "Clover",
  "cactus": "Cactus",
  "tree": "Tree"
};

// Plant action configurations
export const PLANT_ACTIONS = {
  "Planted seeds": "",
  "Transplanted": "",
  "Watered": "",
  "Fertilized": "Use every 7 days",
  "NeemAzal": "Use every 7 days, 3 times max",
  "Kytos": "Use every 14 days",
  "Copfort": "Use every 14 days",
  "Altozan B/Zn": "Use every 7 days",
  "TerraSorb Foliar": "Use every 7 days",
  "Carial Star": "Use every 10 days, 3 times max",
};


// TO DO event statuses
export const TODO_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  OVERDUE: 'overdue'
};

// Event types
export const EVENT_TYPES = {
  ACTION: 'action',
  TODO: 'todo',
  RECURRING_TODO: 'recurring_todo',
  COMPLETED_ACTION: 'completed_action'
};

// UI Constants
export const UI_CONSTANTS = {
  EVENTS_PER_DAY_MOBILE: 3,
  MAX_ICONS_PER_EVENT: 3,
  DROPDOWN_MAX_HEIGHT: 200,
  MODAL_Z_INDEX: 1055,
  DROPDOWN_Z_INDEX: 9999,
  SIDEBAR_WIDTH: {
    MOBILE: 300,
    TABLET: 250,
    DESKTOP: 300
  }
};

// Breakpoints
export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1025
};

// Date formats
export const DATE_FORMATS = {
  DAY_MONTH_YEAR: "DD-MM-YY",
  FULL_MONTH_YEAR: "MMMM YYYY",
  SHORT_MONTH_YEAR: "MMM YYYY",
  DAY_ABBR: "ddd"
};

// Event action types
export const EVENT_ACTIONS = {
  PUSH: 'push',
  UPDATE: 'update',
  DELETE: 'delete',
  LOAD: 'load'
};

// Colors
export const COLORS = {
  PRIMARY: '#dc3545',
  SECONDARY: '#6c757d',
  SUCCESS: '#28a745',
  DANGER: '#dc3545',
  WARNING: '#ffc107',
  INFO: '#e91e63',
  LIGHT: '#f8f9fa',
  DARK: '#343a40',
  
  // Custom app colors
  TITLE_DARK: '#2c3e50',
  TITLE_LIGHT: '#6c757d',
  GRADIENT_START: '#ff6b6b',
  GRADIENT_END: '#4ecdc4'
};

// Animation durations
export const ANIMATIONS = {
  FAST: '0.2s',
  NORMAL: '0.3s',
  SLOW: '0.6s'
}; 